<div class="flex space-between">
  <div class="heading-1 break-word">{{ 'general.api_menu_service_fees' | translate }}</div>
  <div>
    <button mat-stroked-button color="primary" class="compact-medium" (click)="createServiceFee()">
      {{ 'general.api_fees_create_new' | translate }}
    </button>
  </div>
</div>
<app-loader [loading]="isLoading" [overlay]="true"></app-loader>
<form #searchForm="ngForm" cdkScrollable class="filter filter-with-tabs no-print" (ngSubmit)="search()">
  <div class="flex flex-column-mobile flex-wrap flex-filters bottom-spacer">
    <!-- Name -->
    <app-text-input [label]="'general.api_service_fees_name'" [(value)]="filters.name"></app-text-input>
    <!-- Points of sale -->
    <mat-form-field appearance="outline" class="no-hint" >
      <mat-label>{{ 'general.api_service_fees_salespoints' | translate }}</mat-label>
      <mat-select [(ngModel)]="filters.salespointIds" [ngModelOptions]="{standalone: true}" [multiple]="true">
        <mat-select-trigger>{{ displaySalespointsByIds(filters.salespointIds) }}</mat-select-trigger>
        <mat-option>
          <app-select-search [values]="salespoints" [filterBy]="['name']" (filteredValues)="salespointsFiltered.next($event.slice())"></app-select-search>
        </mat-option>
        <mat-option *ngFor="let salespoint of salespointsFiltered | async" [value]="salespoint.id">
          {{ salespoint.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="flex flex-column-reverse-mobile">
      <button mat-button type="button" (click)="clearFilters()">
        {{ 'general.api_general_clear' | translate }}
      </button>
      <button mat-flat-button type="submit" color="primary">
        {{ 'general.api_service_fees_search' | translate }}
      </button>
    </div>
  </div>
</form>
<mat-tab-group mat-align-tabs="left" class="tabs no-body max-width bottom-spacer" [(selectedIndex)]="activeTab" (selectedIndexChange)="changeTab()">
  <mat-tab [label]="'general.api_service_fees_tab_active' | translate"></mat-tab>
  <mat-tab [label]="'general.api_service_fees_tab_inactive' | translate"></mat-tab>
</mat-tab-group>
<ng-container *ngIf="!isLoading">
  <app-info-message *ngIf="!serviceFees?.items?.length"
                    [message]="'general.api_service_fees_no_results'" [large]="true"></app-info-message>
  <mat-card appearance="outlined" *ngIf="serviceFees?.items?.length">
    <app-pagination [page]="filters.page" [pageSize]="filters.pageSize" [total]="serviceFees.total" (pageChange)="search($event)"></app-pagination>
    <table class="report-table manual-alternating-color" *ngIf="!utilService.isMobile">
      <thead>
      <tr>
        <th class="min-width">
          <button mat-button class="icon-button input-button small" (click)="areAllExpanded ? collapseAll() : expandAll()" [disabled]="!expandableFeesExist">
            <mat-icon class="svg-icon" [svgIcon]="areAllExpanded ? 'accordion_up' : 'accordion_down'"></mat-icon>
          </button>
        </th>
        <th>{{ 'general.api_fees_table_fee_name' | translate }}</th>
        <th>{{ 'general.api_fees_table_fee_salespoints' | translate }}</th>
        <th class="align-right">{{ 'general.api_fees_table_fee_amount' | translate }}</th>
        <th class="align-right">{{ 'general.api_fees_table_fee_vat' | translate }}</th>
        <th>{{ 'general.api_fees_table_fee_start' | translate }}</th>
        <th>{{ 'general.api_fees_table_fee_end' | translate }}</th>
        <th>{{ 'general.api_fees_table_fee_refundable' | translate }}</th>
        <th class="min-width">&nbsp;</th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngFor="let fee of serviceFees.items; let even = even">
        <tr *ngIf="!fee.periodPrices?.length" [ngClass]="{'alternate' : even}">
          <td class="min-width">&nbsp;</td>
          <td>
            <app-link [link]="(fee.translations | translateValue) || '-'" (linkClicked)="editServiceFee(fee)" [wrap]="true"></app-link>
            <br><span class="text-muted">{{ fee.name }}</span>
          </td>
          <td>
            <app-show-more [inputItems]="fee.salespoints" [inputTemplate]="showMoreTemplate" [maxItems]="3"></app-show-more>
          </td>
          <td class="align-right">-</td>
          <td class="align-right">-</td>
          <td>-</td>
          <td>-</td>
          <td>{{ (fee.isRefundable ? 'general.api_fees_refundable_true' : 'general.api_fees_refundable_false') | translate }}</td>
          <td>
            <button mat-button class="icon-button input-button small" (click)="editServiceFee(fee)">
              <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
            </button>
          </td>
        </tr>
        <ng-container *ngIf="activeTab === 1" [ngTemplateOutlet]="feeRowsTemplate"
                      [ngTemplateOutletContext]="{fee: fee, periodPriceList: fee.pastPeriodPrices, evenRow: even}">
        </ng-container>
        <ng-container *ngIf="activeTab === 0" [ngTemplateOutlet]="feeRowsTemplate"
                      [ngTemplateOutletContext]="{fee: fee, periodPriceList: fee.currentAndFuturePeriodPrices, evenRow: even}"></ng-container>
      </ng-container>
      </tbody>
    </table>
    <ng-template #feeRowsTemplate let-fee="fee" let-periodPriceList="periodPriceList" let-evenRow="evenRow">
      <tr *ngFor="let periodPrice of periodPriceList; let first = first" [ngClass]="{'alternate' : evenRow}">
        <td class="min-width" *ngIf="first" [rowSpan]="expanded[fee.id] ? (periodPriceList?.length || 1) : 1">
          <button mat-button class="icon-button input-button small" *ngIf="periodPriceList?.length > 1"
                  (click)="$event.stopPropagation(); toggleFee(fee.id)">
            <mat-icon class="svg-icon" [svgIcon]="expanded[fee.id] ? 'arrow_up' : 'arrow_down'"></mat-icon>
          </button>
        </td>
        <td *ngIf="first" [rowSpan]="expanded[fee.id] ? (periodPriceList?.length || 1) : 1">
          <app-link [link]="(fee.translations | translateValue) || '-'" (linkClicked)="editServiceFee(fee)" [wrap]="true"></app-link>
          <br><span class="text-muted">{{ fee.name }}</span>
        </td>
        <td *ngIf="first" [rowSpan]="expanded[fee.id] ? (periodPriceList?.length || 1) : 1">
          <app-show-more [inputItems]="fee.salespoints" [inputTemplate]="showMoreTemplate" [maxItems]="3"></app-show-more>
        </td>
        <td class="align-right white-space-no-wrap" *ngIf="expanded[fee.id] || first">{{ periodPrice.feeAmount | price }}</td>
        <td class="align-right white-space-no-wrap" *ngIf="expanded[fee.id] || first">{{ periodPrice.vatPercentage ? (periodPrice.vatPercentage + '%') : '' }}</td>
        <td *ngIf="expanded[fee.id] || first">{{ periodPrice.period.start | moment: { format: viewService.conf.dateTimeFormat } }}</td>
        <td *ngIf="expanded[fee.id] || first">{{ periodPrice.period.end ? (periodPrice.period.end | moment: { format: viewService.conf.dateTimeFormat }) : '...' }}</td>
        <td *ngIf="first" [rowSpan]="expanded[fee.id] ? (periodPriceList?.length || 1) : 1">
          {{ (fee.isRefundable ? 'general.api_fees_refundable_true' : 'general.api_fees_refundable_false') | translate }}
        </td>
        <td class="min-width" *ngIf="first" [rowSpan]="expanded[fee.id] ? (periodPriceList?.length || 1) : 1">
          <button mat-button class="icon-button input-button small" (click)="editServiceFee(fee)">
            <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
          </button>
        </td>
      </tr>
    </ng-template>
    <ng-container *ngIf="utilService.isMobile">
      <div class="listing-block" *ngFor="let fee of serviceFees.items; let even = even; let index = index; let last = last" [ngClass]="{'last-block': last}">
        <div class="header-block flex flex-grow space-between bottom-spacer">
          <div>
            <app-link [link]="(fee.translations | translateValue) || '-'" [mobileHeading]="true" (linkClicked)="editServiceFee(fee)" [wrap]="true"></app-link>
            <span class="text-muted body-3">{{ fee.name }}</span>
          </div>
          <div class="white-space-no-wrap no-grow no-min-width">
            <button mat-button class="icon-button input-button" (click)="editServiceFee(fee)">
              <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
            </button>
          </div>
        </div>
        <table class="mobile-max-width bottom-spacer">
          <tbody>
          <tr>
            <td>{{ 'general.api_fees_table_fee_salespoints' | translate }}</td>
            <td class="align-right">
              <app-show-more [inputItems]="fee.salespoints" [inputTemplate]="showMoreTemplate" [maxItems]="3"></app-show-more>
            </td>
          </tr>
          <ng-container *ngIf="!fee.periodPrices?.length">
            <tr class="with-separator">
              <td>{{ 'general.api_fees_table_fee_amount' | translate }}</td>
              <td class="align-right">-</td>
            </tr>
            <tr>
              <td>{{ 'general.api_fees_table_fee_vat' | translate }}</td>
              <td class="align-right">-</td>
            </tr>
            <tr>
              <td>{{ 'general.api_fees_table_fee_start' | translate }}</td>
              <td class="align-right">-</td>
            </tr>
            <tr>
              <td>{{ 'general.api_fees_table_fee_end' | translate }}</td>
              <td class="align-right">-</td>
            </tr>
          </ng-container>
          <ng-container *ngIf="activeTab === 1" [ngTemplateOutlet]="mobilePeriodPriceTemplate"
                        [ngTemplateOutletContext]="{fee: fee, periodPriceList: fee.pastPeriodPrices}">
          </ng-container>
          <ng-container *ngIf="activeTab === 0" [ngTemplateOutlet]="mobilePeriodPriceTemplate"
                        [ngTemplateOutletContext]="{fee: fee, periodPriceList: fee.currentAndFuturePeriodPrices}"></ng-container>
          </tbody>
        </table>
        <hr class="no-margin">
      </div>
      <ng-template #mobilePeriodPriceTemplate let-fee="fee" let-periodPriceList="periodPriceList">
        <ng-container *ngFor="let periodPrice of periodPriceList; let first = first">
          <ng-container *ngIf="first || expanded[fee.id]">
            <tr class="with-separator">
              <td>{{ 'general.api_fees_table_fee_amount' | translate }}</td>
              <td class="align-right">{{ periodPrice.feeAmount | price }}</td>
            </tr>
            <tr>
              <td>{{ 'general.api_fees_table_fee_vat' | translate }}</td>
              <td class="align-right">{{ periodPrice.vatPercentage ? (periodPrice.vatPercentage + '%') : '' }}</td>
            </tr>
            <tr>
              <td>{{ 'general.api_fees_table_fee_start' | translate }}</td>
              <td class="align-right">{{ periodPrice.period.start | moment: { format: viewService.conf.dateTimeFormat } }}</td>
            </tr>
            <tr>
              <td>{{ 'general.api_fees_table_fee_end' | translate }}</td>
              <td class="align-right">{{ periodPrice.period.end ? (periodPrice.period.end | moment: { format: viewService.conf.dateTimeFormat }) : '...' }}</td>
            </tr>
          </ng-container>
        </ng-container>
        <tr class="with-separator">
          <td>{{ 'general.api_fees_table_fee_refundable' | translate }}</td>
          <td class="align-right">{{ (fee.isRefundable ? 'general.api_fees_refundable_true' : 'general.api_fees_refundable_false') | translate }}</td>
        </tr>
        <tr *ngIf="periodPriceList?.length > 1">
          <td colspan="2" class="align-center">
            <app-link [link]="(expanded[fee.id] ? 'general.api_show_less' : 'general.api_show_more')" (linkClicked)="toggleFee(fee.id)"
                      [icon]="expanded[fee.id] ? 'arrow_up' : 'arrow_down'" [linkClass]="'body-3 medium'"></app-link>
          </td>
        </tr>
      </ng-template>
    </ng-container>
    <app-pagination [page]="filters.page" [pageSize]="filters.pageSize" [total]="serviceFees.total" (pageChange)="search($event)"></app-pagination>
  </mat-card>
</ng-container>
<ng-template #showMoreTemplate let-item="item" let-lastItem="lastItem">
  <span>{{ nameByIdDisplay(item, salespoints) }}<ng-container *ngIf="!lastItem">;&nbsp;</ng-container><ng-container *ngIf="lastItem">&nbsp;</ng-container></span>
</ng-template>
